<div class="file-comparison-info">
  <div class="font-size-16 font-weight-700 mb-16">Validação</div>

  <div class="font-size-14 font-weight-400 mb-16">
    Compare os dois documentos e responda os itens abaixo para saber a
    recomendação
  </div>

  <div [formGroup]="answers" class="answers">
    <div class="question-row">
      <div class="question-text">
        O pdf original possui assinatura digital válida?
      </div>
      <app-button-toggle-group-form
        formControlName="validDigitalSignature"
        [options]="OPTIONS"
      ></app-button-toggle-group-form>
    </div>
    <div class="question-row">
      <div class="question-text">O nome do funcionário é igual?</div>
      <app-button-toggle-group-form
        formControlName="sameName"
        [options]="OPTIONS"
      ></app-button-toggle-group-form>
    </div>
    <div class="question-row">
      <div class="question-text">Os dados do emissor são iguais?</div>
      <app-button-toggle-group-form
        formControlName="sameIssuerData"
        [options]="OPTIONS"
      ></app-button-toggle-group-form>
    </div>
    <div class="question-row">
      <div class="question-text">O tempo de afastamento é igual?</div>
      <app-button-toggle-group-form
        formControlName="sameLeaveDuration"
        [options]="OPTIONS"
      ></app-button-toggle-group-form>
    </div>
    <div class="question-row">
      <div class="question-text">O tipo exige assinatura digital?</div>
      <app-button-toggle-group-form
        formControlName="requiredDigitalSignature"
        [options]="OPTIONS"
      ></app-button-toggle-group-form>
    </div>
  </div>

  <div
    *ngIf="requirementsAreMet == null; else answerIsComputed"
    class="requirements-unknown font-size-14 font-weight-500"
  >
    Recomendação
  </div>

  <ng-template #answerIsComputed>
    <div
      *ngIf="requirementsAreMet"
      class="requirements-are-met font-size-14 font-weight-500"
    >
      <app-icon>check</app-icon>
      <div class="alert-message">
        O documento atende a todos os requisitos de validação
      </div>
    </div>

    <div
      *ngIf="!requirementsAreMet"
      class="requirements-are-not-met font-size-14 font-weight-500"
    >
      <app-icon>close</app-icon>
      <div class="alert-message">
        O documento não atende a todos os requisitos de validação
      </div>
    </div>
  </ng-template>
</div>

<div class="file-comparison-item original-file">
  <span class="font-size-16 font-weight-700">PDF original</span>
  <app-file-preview
    class="file-wrapper"
    [fileSrc]="downloadedFile.url"
    [fileName]="downloadedFile.name"
    [fileType]="downloadedFile.type"
    [showQrCodeButton]="false"
    [status]="status"
    [signerName]="signerName"
    [signerCPF]="signerCPF"
    [signerCNPJ]="signerCNPJ"
  ></app-file-preview>
</div>

<div class="file-comparison-item">
  <span class="font-size-16 font-weight-700">Enviado pelo funcionário</span>
  <app-file-preview
    class="file-wrapper"
    [fileSrc]="originalFile.url"
    [fileName]="originalFile.name"
    [fileType]="originalFile.type"
    [showQrCodeButton]="false"
    [showSignaturePopover]="false"
  ></app-file-preview>
</div>

<app-button class="close-button" size="circle-small" (click)="close()">
  <app-icon>close</app-icon>
</app-button>
